import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  min-height: 400px;
  border-radius: 20px;
  overflow: hidden;
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: ${themeGet('space.11')}px 0;

  > img {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  p,
  button {
    z-index: 2;
  }
`

export const Overflow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.overlay.primaryAlt')};
  z-index: 1;
`
